import React, { useContext, useState, useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import {
  makeStyles,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  IconButton,
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import { head } from "lodash";
import { ToastContainer, toast } from 'react-toastify';
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Title from "../Title";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import useSettings from "../../hooks/useSettings";
import { grey, blue } from "@material-ui/core/colors";
import ButtonWithSpinner from "../ButtonWithSpinner";


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  mainPaper: {
    width: "100%",
    flex: 1,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.fancyBackground,
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: 240,
  },
  tab: {
    background: "#f2f5f3",
    borderRadius: 4,
    width: "100%",
    "& .MuiTab-wrapper": {
      color: "#128c7e"
    },
    "& .MuiTabs-flexContainer": {
      justifyContent: "center"
    }


  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    marginBottom: 12,
    width: "100%",
  },
  cardAvatar: {
    fontSize: "55px",
    color: grey[500],
    backgroundColor: "#ffffff",
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    color: blue[700],
  },
  cardSubtitle: {
    color: grey[600],
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
  },
  buttonContainer: {
    textAlign: "right",
    padding: theme.spacing(1),
  },
  fullWidth: {
    width: "100%",
  },
  fileInput: {
    background: "red",
  },
  fileInputLabel: {
    display: "inline-block",
    backgroundColor: "#364a6b",
    color: "#fff",
    padding: "8px 16px",
    borderRadius: "4px",
    width: "98%",
    marginLeft: "14px",
    cursor: "pointer",
    "& input": {
      display: "none",
    },
  },
}));

const UploaderCert = () => {
  const [file, setFile] = useState(null);
  const [uploaded, setUploaded] = useState(false);
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const { profile } = user;
  const history = useHistory();
  const [selectedFileName, setSelectedFileName] = useState('');



  // trava para nao acessar pagina que não pode 
  useEffect(() => {
    async function fetchData() {
      if (!user.super) {
        toast.error("Sem permissão para acessar!");
        setTimeout(() => {
          history.push(`/`)
        }, 500);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const fileName = selectedFile.name;
      if (fileName.endsWith(".p12")) {
        setFile(selectedFile);
        setSelectedFileName(fileName);
      } else {
        setFile(null);
        setSelectedFileName(null);
        toast.error("Use somente arquivos em formato p12!");
      }
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!file) {
      toast.warn("Escolha um arquivo!");
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    try {
      const response = await api.post(`/settings/cert-upload?ref=certificadoEfi`, formData);

      if (response.data.mensagem === 'Arquivo Anexado') {
        setUploaded(true);
        toast.success("Arquivo enviado com sucesso!");
        window.location.reload();

      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Grid spacing={3} container>
        <form onSubmit={handleSubmit} className={classes.fullWidth}>

          <Grid item xs={12} sm={12} md={12} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <FormControl style={{ flex: 1 }}>
              <label className={classes.fileInputLabel} style={{ marginTop: 4, marginBottom: 4 }}>
                <input
                  type="file"
                  onChange={handleFileChange}
                  className={classes.fileInput}
                  style={{ marginTop: 10, marginBottom: 10 }}
                />
                {selectedFileName ? selectedFileName : 'Upload Certificado Efí p12 API PIX'}
              </label>
            </FormControl>
            <ButtonWithSpinner
              type="submit"
              variant="contained"
              color="primary"
              style={{ minWidth: 70, height: 40, fontSize: 11, whiteSpace: 'nowrap', flexShrink: 0, marginRight: 16 }}
            >
              Enviar
            </ButtonWithSpinner>
          </Grid>
        </form>
      </Grid>
    </>
  );
};

export default UploaderCert;